import React, { useEffect } from "react";
import { Combobox, Toast, AddUser } from "../../";
import { useState } from "react";
import { apis, get } from "../../../Utils/axios";
import EmployeeInfo from "../../Cards/EmployeeInfo";

function EmployeeSearch({
	onSelect = () => {},
	placeholder = "Search Users",
	label,
	selected = {},
	searchOnly = false,
	className = "",
	prefetch = true,
}) {
	const [AllUsers, setAllUsers] = useState([]);
	const [Loader, setLoader] = useState();

	const fetchUsers = (query) => {
		setLoader(true);
		const params = { page: 1 };
		if (query) {
			params.search = query;
		}

		get(searchOnly ? apis.searchUsers : apis.getAllUsers, params, (r, e) => {
			if (r) {
				setAllUsers(r.users);
				setLoader(false);
			} else if (e) {
				console.log(e);
				Toast.handleError(e);
				setLoader(false);
			}
		});
	};

	const onChange = (query) => {
		fetchUsers(query);
	};

	useEffect(() => {
		if (prefetch) {
			fetchUsers("");
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [prefetch]);

	return (
		<div className="flex items-end w-full gap-2">
			<Combobox
				loading={Loader}
				label={label}
				placeholder={placeholder}
				className={className}
				onChange={onChange}
				options={AllUsers.map((user) => ({
					...user,
					label: `${user.fName} ${user.lName}`,
					value: user.id,
				}))}
				selected={selected}
				onSelect={onSelect}
				renderItem={(employee, i) => (
					<li className="!p-0 hover:bg-light">
						<EmployeeInfo className="w-full" key={i} employee={employee} />
					</li>
				)}
			/>
			{!searchOnly && <AddUser btnLabel="+ New" />}
		</div>
	);
}

export default EmployeeSearch;
